// extracted by css-extract-rspack-plugin
export default {"list":"list-sL60Mb","debt":"debt-Xk2Ofu","row":"row-UwhWaL","debt-delete":"debt-delete-dNgGAI","debtDelete":"debt-delete-dNgGAI"};